// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"e410a32fde1634817b6b","883":"df4780d003f30e22a439"}[chunkId] + ".js";
};